import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/migration.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "migrating-to-aepsignal-reference"
    }}>{`Migrating to AEPSignal reference`}</h1>
    <p>{`This document is a reference comparison of AEPSignal (3.x) APIs against their equivalent ACPSignal (2.x) APIs.`}</p>
    <p>{`The AEPSignal extension is implemented purely in Swift and is compatible with the AEPCore Swift SDK. To ensure a smooth transition from the ACPSignal SDK, there are no major changes on the API names or definitions. For more details, follow the migration guide below for your Swift or Objective-C mobile application. If explanation beyond showing API differences is necessary, it will be captured as an info hint within that API's section.`}</p>
    <h2 {...{
      "id": "public-classes"
    }}>{`Public classes`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`AEP 3.x (Swift)`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`AEP 3.x (Objective-C)`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`ACP 2.x (Objective-C)`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Primary Class`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Signal`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`AEPMobileSignal`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ACPSignal`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "public-apis"
    }}>{`Public APIs`}</h2>
    <h3 {...{
      "id": "extensionversion"
    }}>{`extensionVersion`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=extension-version" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=extension-version" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=extension-version" mdxType="Tabs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      